<div [ngClass]="{'mt-4' :showTitle || showSubtitle, 'inParagraph mb-3': type == 'paragraph' }" class="col-12 px-0">

  <h5 *ngIf="showTitle"
      class="mb-0 pb-4 title_2">{{ 'PROCESSES.ACCOMMODATION.POST_RESERVATION.NEED_HELP' | translate}}</h5>

  <p *ngIf="showSubtitle" class="text_1 mediumGray pb-4">{{ 'HELP.AGENT.SUBTITLE_2'| translate }}</p>

  <div class="rounded-pill w-fit-content lf-after-bg border box-shadow bg-white pointer"
       (click)="openChat()" [ngClass]="{'w-100': type == 'contacts'}">
    <div class="rounded-pill bg-white d-flex flex-row p-2 gap-24 align-items-center">
      <img
        alt=""
        class="rounded-circle" src="/assets/img/{{ type == 'contacts' ? ('people/' + contact.avatar) : ('admin/agents/' + contact.firstname.toLowerCase() + '.png') }}">

      <div
        [ngClass]="type == 'LF' || type == 'paragraph' || (type == 'contacts' && !contact.email &&  !contact.phone) ? 'flex-column' : 'flex-row flex-wrap align-items-center w-100 pe-4'"
        class="d-flex">

        <span [ngClass]="{'flex-grow-1': type == 'contacts'}"
              class="font-trueno-bold font-14 text-black">{{ (type != 'paragraph' ? contact.lastname + ' ' : '') + contact.firstname }}</span>

        <a #mailTo (click)="$event.stopPropagation()" *ngIf="contact.email && type != 'paragraph'"
           [ngClass]="type == 'LF' ? 'text-black' : 'mediumGray w-50'"
           class="font-12 " href="mailto:{{ contact.email }}">
          <span class="material-icons-outlined font-16 va-sub text-black" *ngIf="type == 'contacts'">email</span>
          {{ contact.email }}
        </a>

        <span *ngIf="type == 'contacts' && contact.poste" [ngClass]="{'flex-grow-1': type == 'contacts'}"
              class="lightGray2 font-12">{{ contact.poste }}</span>

        <p *ngIf="type == 'paragraph'" class="minitext_2">Livinfrance support</p>

        <span *ngIf="type == 'contacts' && contact.phone" class="mediumGray font-12 w-50">
          <span class="material-icons-outlined font-16 va-sub text-black">connect_without_contact</span>
          {{contact.phone}}
        </span>

      </div>

      <span *ngIf="type == 'LF'"
        class="material-icons-outlined text-white bg-success rounded-circle d-flex align-items-center justify-content-center font-22 position-relative overflow-hidden">chat</span>
    </div>
  </div>

  <p *ngIf="type == 'LF'" class="minitext_1 mediumGray mt-3">{{ 'HELP.AGENT.DISPONIBILITY'| translate }}</p>

</div>
